export default __webpack_public_path__ + "static/media/2.8305e058.JPG";